// Labels and helpers shared by the document review views.

export const STATUS_LABELS = {
  uploaded: 'Uploaded',
  queued: 'Queued',
  parsing: 'Parsing…',
  parsed: 'Ready for review',
  error: 'Failed',
};

export const isBusy = (status) => status === 'queued' || status === 'parsing' || status === 'uploaded';

export const BLOCK_TYPE_LABELS = {
  title: 'Title',
  heading: 'Heading',
  paragraph: 'Body',
  list_item: 'List',
  table: 'Table',
  figure: 'Figure',
  caption: 'Caption',
  toc: 'TOC',
  page_break: 'Page break',
  equation: 'Equation',
  unsupported: 'Unsupported',
};

export const ISSUE_LABELS = {
  possible_heading: 'Possible heading',
  skipped_heading_level: 'Skipped heading level',
  empty_heading: 'Empty heading',
  no_headings: 'No headings',
  orphan_caption: 'Caption without figure/table',
  uncaptioned_figure: 'Figure without caption',
  low_res_image: 'Low-resolution image',
  fair_res_image: 'Image below 220 dpi',
  image_unreadable: 'Unreadable image',
  chart_no_image: 'Chart without picture',
  embedded_object: 'Embedded object',
  wide_table: 'Wide table',
  long_table: 'Long table',
  table_no_header: 'Table without header row',
  nested_tables: 'Nested tables',
  tracked_changes: 'Tracked changes',
  comments: 'Comments',
  toc_regenerated: 'Table of contents',
  source_cover: 'Word cover page',
  landscape_sections: 'Landscape sections',
  equation: 'Equation',
};

export const OVERRIDE_LABELS = {
  set_heading: (level) => `Heading ${level}`,
  set_body: () => 'Body',
  set_caption: () => 'Caption',
  set_callout: () => 'Callout',
  exclude: () => 'Excluded',
  keep: () => 'Confirmed',
};

export function overrideLabel(override) {
  if (!override) return null;
  const fn = OVERRIDE_LABELS[override.action];
  return fn ? fn(override.level) : override.action;
}

/** Block as it will be rendered once the reviewer's override is applied. */
export function effectiveBlock(block) {
  const o = block.override;
  if (!o || o.action === 'keep') return block;
  if (o.action === 'set_heading') return { ...block, block_type: 'heading', level: o.level };
  if (o.action === 'set_body') return { ...block, block_type: 'paragraph', level: null };
  if (o.action === 'set_caption') return { ...block, block_type: 'caption' };
  if (o.action === 'set_callout') return { ...block, role: 'callout' };
  if (o.action === 'exclude') return { ...block, excluded: true };
  return block;
}

export const confidenceClass = (c) => (c >= 0.9 ? 'high' : c >= 0.7 ? 'medium' : 'low');
